import { ActionsUnion, createAction } from "@bookingcom/flights-core";
import { UIClientFetchError, UIBrandedFare } from "@flights/types";

export enum ActionTypes {
  fetch = "brandedFares/fetch",
  fetchSuccess = "brandedFares/fetchSuccess",
  fetchError = "brandedFares/fetchError",
  reset = "brandedFares/reset",
  selectFare = "brandedFares/selectFare"
}

export const actions = {
  fetch: createAction((baseOfferToken: string) => ({
    type: ActionTypes.fetch,
    payload: { baseOfferToken }
  })),

  fetchSuccess: createAction((brandedFaresOffers: Array<UIBrandedFare>, baseOfferToken: string) => ({
    type: ActionTypes.fetchSuccess,
    payload: { brandedFaresOffers, baseOfferToken }
  })),

  fetchError: createAction((error: UIClientFetchError, baseOfferToken: string) => ({
    type: ActionTypes.fetchError,
    payload: { error, baseOfferToken }
  })),

  /* start - flights_apex_web_fetch_branded_fare_flight_details */
  selectFare: createAction((fareToken: string) => ({
    type: ActionTypes.selectFare,
    payload: { fareToken }
  })),
  /* end - flights_apex_web_fetch_branded_fare_flight_details */

  reset: createAction(() => ({
    type: ActionTypes.reset,
    payload: {}
  }))
};

export type Actions = ActionsUnion<typeof actions>;
